import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_GET_HALAL_STOCK } from "../../../config/api";

export const getStock = createAsyncThunk(
  "stocks/getOne",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: API_GET_HALAL_STOCK + id,
      });

      return response?.data?.data?.stock;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
